import React, { useState } from "react";
import { TableColumnsType, Tag } from "antd";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import TransactionFlowDefaultTemplate from "../others/transactionFlowDefaultTemplate";
import WorkBoqAside from "./workBoqAside";

interface WorkBoqApprovalData {
  id: string;
  boqTitle: string;
  siteName: string;
  workLevel: string;
  contractor: string;
  totalLines: number;
  status: "Pending Approval" | "Approved" | "Rejected";
  submittedAt: string;
  submittedBy: string;
  approvalLevel: string;
  currentApprover: string;
}

const WorkBoqApprovals: React.FC = () => {
  const [sm, setSm] = useState(false);

  const getStatusColor = (status: string) => {
    const statusColors: { [key: string]: string } = {
      "Pending Approval": "processing",
      "Approved": "success",
      "Rejected": "error",
    };
    return statusColors[status] || "default";
  };

  const columns: TableColumnsType<WorkBoqApprovalData> = [
    {
      title: "BOQ ID",
      dataIndex: "id",
      key: "id",
      width: 100,
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "BOQ Details",
      dataIndex: "boqTitle",
      key: "boqTitle",
      width: 300,
      render: (text, record) => (
        <div>
          <Link to={`/work-boq-view/${record.id}`} className="fw-bold text-primary">
            {text}
          </Link>
          <div className="text-muted small mt-1">{record.siteName}</div>
        </div>
      ),
    },
    {
      title: "Work Level",
      dataIndex: "workLevel",
      key: "workLevel",
      width: 120,
      render: (text) => (
        <Tag color="blue">{text}</Tag>
      ),
    },
    {
      title: "Contractor",
      dataIndex: "contractor",
      key: "contractor",
      width: 180,
    },
    {
      title: "Lines",
      dataIndex: "totalLines",
      key: "totalLines",
      width: 80,
      align: "center",
      render: (text) => (
        <span className="badge badge-soft-info">{text}</span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 140,
      render: (status) => (
        <Tag color={getStatusColor(status)}>{status}</Tag>
      ),
    },
    {
      title: "Approval Level",
      dataIndex: "approvalLevel",
      key: "approvalLevel",
      width: 140,
      render: (text, record) => (
        <div>
          <div className="fw-bold">{text}</div>
          <small className="text-muted">{record.currentApprover}</small>
        </div>
      ),
    },
    {
      title: "Submitted",
      dataIndex: "submittedAt",
      key: "submittedAt",
      width: 140,
      render: (text, record) => (
        <div>
          <div>{dayjs(text).format("DD-MMM-YYYY")}</div>
          <small className="text-muted">by {record.submittedBy}</small>
        </div>
      ),
    },
  ];

  return (
    <TransactionFlowDefaultTemplate
      moduleKey="work-boq-approvals"
      title="Work BOQ Approvals"
      columns={columns}
      sideNavigation={
        <div
          className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
            sm ? "content-active" : ""
          }`}
        >
          <WorkBoqAside updateSm={setSm} sm={sm} />
        </div>
      }
      extra={{
        tableScrollX: 1100,
      }}
    />
  );
};

export default WorkBoqApprovals;